import Vue from "vue";
import MenuRightSerivce from "@/service/MenuRightService";
import SweetAlertService from "@/service/SweetAlertService";
import StaffService from "@/service/StaffService";
import StaffEmploymentService from "@/service/StaffEmploymentService";
import StoreGetter from "@/constants/StoreGetter";
import { PayProfile } from "@/model/PayProfile";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import Setting from "@/constants/Settings";
import PayProfileService from "@/service/PayProfileService";
import CompanyService from "@/service/CompanyService";
import PayTypeService from "@/service/PayTypeService";
import PayGroupService from "@/service/PayGroupService";
import payProfileValidation from "./S081900-PayProfileValidation.js";
import Paginate from "vuejs-paginate";
import moment from "moment";
var payProfileObj = new payProfileValidation();
export default {
    name: "payProfile",
    mounted() {
        payProfileObj.payProfileValidation();
        this.assignRights();
        this.getAllPayProfile()
        this.getDeptList();
        this.getCompList();
        this.getStaffList();
        this.getPayGroupList();
        this.getPayTypeList();
        this.getPerPage();
    },
    components: {
        paginate: Paginate,
    },
    data: () => ({
        menuRights: { allRights: {}, rightsForThisMenu: {} },
        menuId: Setting.MenuID.S_PayProfile,
        dictEnum: dictEnum,
        payProfile: new PayProfile(),
        isEditMode: false,
        payProfileList: [],
        selectAllPayProfile: false,
        selectedPayProfileModel: new PayProfile(),
        compList: [],
        deptList: [],
        payGrpList: [],
        payTypeList: [],
        staffList: [],
        search: {
            Company: "",
            Dept: "",
            PayGroup: "",
            PayType: ""
        },
        currentPage: 1,
        perPage: 15,
        fields: [
            {
                key: "CompCode",
                label: t.t(dictEnum.LBL_Company)
            },
            {
                key: "StaffID",
                label: t.t(dictEnum.LBL_StaffID)
            },
            {
                key: "Name",
                label: t.t(dictEnum.LBL_Name)
            },
            {
                key: "JobTitle",
                label: t.t(dictEnum.LBL_JobTitle)
            },
            {
                key: "EmpType",
                label: t.t(dictEnum.LBL_EmpType)
            },
            {
                key: "JoinDate",
                label: t.t(dictEnum.LBL_DateJoin)
            },
            {
                key: "YOS",
                label: t.t(dictEnum.LBL_YOS)
            },
            {
                key: "PayGrpCode",
                label: t.t(dictEnum.LBL_PayGroup)
            },
            {
                key: "PayRate",
                label: t.t(dictEnum.LBL_Rate)
            },
            {
                key: "VCR",
                label: t.t(dictEnum.LBL_VCR)
            },
            {
                key: "VCE",
                label: t.t(dictEnum.LBL_VCE)
            },
            {
                key: "Action",
                label: ""
            }
        ],
    }),
    computed: {
        t() {
            return t;
        },
        user() {
            return this.$store.getters[StoreGetter.user];
        },
    },
    methods: {
        hasRight(key, menuId) {
            if (Object.keys(this.menuRights.allRights).length === 0) {
                return false;
            } else {
                return MenuRightSerivce.hasRightInMenu(
                    this.menuRights.allRights,
                    menuId ? menuId : this.menuId,
                    key
                );
            }
        },
        assignRights() {
            this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
            this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
                x => x.MenuID == this.menuId
            );
        },

        getPerPage() {
            setTimeout(() => {
                const tableEle = document.getElementsByClassName("tableHg");
                const trEle = document.getElementsByTagName('tr');
                const tableHeight = tableEle[0].offsetHeight;
                if (trEle.length > 1) {
                    const thHeight = trEle[0].offsetHeight;
                    const tdHeight = trEle[1].offsetHeight;
                    let page = (tableHeight - thHeight) / (tdHeight + 2);
                    this.perPage = page.toFixed(0);
                }
            }, 500);
        },

        PayGrpName(PayGrpCode) {
            const grp = this.payGrpList.find((x) => x.Grp == PayGrpCode);
            if (grp) {
                return grp.GrpDesc
            } else {
                return ""
            }
        },

        async getCompList() {
            var self = this;
            var obj = {
                take: 100,
                skip: 0,
            }
            const response = await CompanyService.getAllCompanyList(obj);
            if (response.data.IsSuccess) {
                self.compList = response.data.Data.Item1;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        async getDeptList() {
            var self = this;
            var obj = {}
            const response = await StaffEmploymentService.getAllDepartment(obj);
            if (response.data.IsSuccess) {
                self.deptList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        async getPayGroupList() {
            var self = this;
            var obj = {}
            const response = await PayGroupService.getAllPayGroup(obj);
            if (response.data.IsSuccess) {
                self.payGrpList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        async getPayTypeList() {
            var self = this;
            var obj = {}
            const response = await PayTypeService.getAllPayType(obj);
            if (response.data.IsSuccess) {
                self.payTypeList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        async getStaffList() {
            var self = this;
            var obj = {
                staffID: ""
            }
            const response = await StaffService.getAllStaff(obj);
            if (response.data.IsSuccess) {
                self.staffList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        async getAllPayProfile() {
            var self = this;
            var obj = self.search;
            const response = await PayProfileService.getAllPayProfile(obj);
            if (response.data.IsSuccess) {
                self.payProfileList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        selectAllPayProfileRecord: function () {
            var self = this;
            var IsSelected = self.selectAllPayProfile;
            self.payProfileList.forEach(function (val, index) {
                val["isSelected"] = IsSelected;
            });
        },
        deleteMultiplePayProfilePopup: function () {
            var arrayList = [];
            var self = this;
            self.payProfileList.forEach(function (key, value) {
                if (key.isSelected) {
                    arrayList.push(key);
                }
            });
            if (arrayList.length > 0) {
                $('#deletePayProfileListModel').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectDeleteRecord));
            }
        },
        async deleteMultiplePayProfile() {
            var arrayList = [];
            var self = this;
            $('#deletePayProfileListModel').modal('hide');
            self.payProfileList.forEach(function (key, value) {
                if (key.isSelected) {
                    arrayList.push(key);
                }
            });
            const obj = {
                assessTempList: arrayList,
            };
            const response = await PayProfileService.deletePayProfile(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetPayProfile();
                await self.getAllPayProfile();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        rowClass(item, type) {
            if (!item || type !== 'row') return
            if (this.selectedPayProfileModel.StaffID == item.StaffID) {
                return 'selected-tr'
            }
        },
        OnPayProfileSelect: function (model) {
            this.selectedPayProfileModel = model;
        },
        addPayProfile: function () {
            var self = this;
            $('#payProfileModel').modal('show');
            self.isEditMode = false;
            self.payProfile = new PayProfile();
            self.$validator.reset();
            self.vErrors.clear();
        },
        async savePayProfileDetail(obj) {
            var self = this;
            const response = await PayProfileService.addPayProfile(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetPayProfile();
                await self.getAllPayProfile();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        async editPayProfile(obj) {
            var self = this;
            const response = await PayProfileService.updatePayProfile(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetPayProfile();
                await self.getAllPayProfile();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        changePayGrp() {
            const find = this.payGrpList.find((x) => x.Grp == this.payProfile.PayGrpCode);
            if (find) {
                this.payProfile.PayTypeCode = find.PayTypeCode
            }
        },
        async savePayProfile() {
            var self = this;
            self.$validator.validateAll().then(result => {
                if (result) {
                    $('#payProfileModel').modal('hide');
                    this.changePayGrp()
                    const obj = {
                        model: {
                            StaffID: self.payProfile.StaffID,
                            PayTypeCode: self.payProfile.PayTypeCode,
                            PayRate: self.payProfile.PayRate,
                            PayGrpCode: self.payProfile.PayGrpCode,
                            VCR: self.payProfile.VCR,
                            VCE: self.payProfile.VCE,
                            DateAdd: self.payProfile.DateAdd,
                            AddBy: self.payProfile.AddBy,
                            DateModify: moment().format(Setting.DateTime.DateTime),
                            ModifyBy: this.user.UserID,
                            RecDel: false
                        }
                    };
                    if (self.isEditMode) {
                        self.editPayProfile(obj);
                    }
                    else {
                        self.savePayProfileDetail(obj);
                    }
                }
            });
        },
        async editPayProfileDetail() {
            var self = this;
            self.isEditMode = true;
            if (self.selectedPayProfileModel.StaffID != "") {
                self.payProfile = this.selectedPayProfileModel;
                self.$validator.reset();
                self.vErrors.clear();
                $('#payProfileModel').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectEditRecord));
            }
        },
        resetPayProfile: function () {
            var self = this;
            self.selectAllPayProfile = false;
            self.isEditMode = false;
            self.payProfile = new PayProfile();
            self.selectedPayProfileModel = new PayProfile();
            self.$validator.reset();
            self.vErrors.clear();
        },
        closePayProfilePopup: function () {
            var self = this;
            self.selectAllPayProfile = false;
            self.isEditMode = false;
            self.payProfile = new PayProfile();
            self.selectedPayProfileModel = new PayProfile();
            self.$validator.reset();
            self.vErrors.clear();
            $('#payProfileModel').modal('hide');
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S081900-PayProfile/S081900-PayProfile.js